<div style="text-align: -webkit-center;text-align: -moz-center;  margin-top: 3rem;">
  <!--*ngIf="charged"-->

  <div class="card" style="margin: 16px; text-align: center; width: 70%;min-width: 50rem">

    <!--ALREADY DONE TEST-->
    <div *ngIf="!done && charged2">
      <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_TEST' | translate}} </p>
    </div>

    <!--SPINNER WHILE LOADING PAGE-->
    <div *ngIf="!done && !charged2" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <div *ngIf="done">
      <div *ngIf="started && ready && configured && sTest && !testFinished" style="text-align: -webkit-left;">
        <div style="width: 20%;">
          <p style="margin: 0;font-weight: 100;font-size: small;">{{'LP_CLOCK' | translate}}: {{second}}/180</p>
          <p style="margin: 0;font-weight: 100;font-size: small;">{{'LP_RATES' | translate}}: {{rated}}/9</p>
        </div>
      </div>
      <h1 *ngIf="!testFinished" style="margin-bottom: 0px; font-size: 3em;">{{'LP_T1' | translate}}</h1>
      <div style="text-align: -webkit-center;text-align: -moz-center;">
        <mat-spinner *ngIf="!ready" diameter="20"></mat-spinner>
      </div>
      <div *ngIf="!started && ready" style="text-align: -webkit-center;text-align: -moz-center;">

        <p [innerHtml]="'LP_P1' | translate">
        </p>

        <p>
          {{'LP_P5' | translate}}
        </p>

        <p>
          {{'LP_P6' | translate}}
        </p>

        <p>
          {{'LP_P7' | translate}}
        </p>

        <p>
          {{'LP_P8' | translate}}
        </p>

        <p>
          {{'LP_P9' | translate}}
        </p>

        <div style="display: flex; justify-content: center; margin-top: 1rem; font-family: akzidenz-grotesk-roman;">
          <div style=" font-size: large;">
            {{'SELECT_AUDIO' | translate}}
            <br />
            <mat-radio-group>
              <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">

                <mat-radio-button [checked]="audioSource === 'headphones'" (change)="setAudioType($event.value)"
                  value="headphones">
                  {{'HEADPH' | translate}}
                </mat-radio-button>
              </div>
              <div style="display: flex; justify-content: start; margin-top: 5px; margin-left: 5px;">
                <mat-radio-button [checked]="audioSource === 'speakers'" (change)="setAudioType($event.value)"
                  value="speakers">
                  {{'SPEAKERS' | translate}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>

        <button matTooltip="{{'AUDIO_TOOLTIP' | translate}}" [matTooltipDisabled]="audioSource" *ngIf="!started"
          mat-raised-button class="button" (click)="start1()" [disabled]="!audioSource">
          {{'START' | translate}}
        </button>
      </div>

      <!--FINISHED TEST-->
      <div *ngIf="started && testFinished">
        <div style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
          <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">
            {{'SUCCESS_TEST' | translate}}
          </p>
        </div>
      </div>

      <div *ngIf="started && !testFinished">
        <div style="margin-top: 2rem;" [ngClass]="{'center-narrow-text': configured && sTest}">
          <p *ngIf="configured && samplePlayed" [ngClass]="{'narrow': configured && sTest}">
            {{'LP_P2' | translate}}
          </p>

          <p *ngIf="configured && !samplePlayed">
            {{'LP_P4' | translate}}
          </p>
          <p *ngIf="!configured && speakersInstructions">
            {{'LP_P10' | translate}}
          </p>
          <p *ngIf="!configured && speakersInstructions">
            {{'LP_P11' | translate}}
          </p>
          <p *ngIf="!configured && !speakersInstructions">
            {{'LP_P3' | translate}}
          </p>

        </div>

        <div style="display: flex; justify-content: center; width: 100%">
        <div class="sound-label" *ngIf="configured && samplePlayed && showLabel">
          100 %
        </div>
        </div>

        <div style="min-height: 100px;" *ngIf="!(configured && sTest)">
          <button *ngIf="!configured && !hideConf && !speakersInstructions" mat-raised-button class="button" (click)="start2()">
            {{'LP_B1' | translate}}
          </button>
          <button *ngIf="!configured && !hideConf && speakersInstructions" mat-raised-button class="button" (click)="next()">
            {{'LP_B4' | translate}}
          </button>
          <!--<button *ngIf="configured && !playSample" mat-raised-button class="button" (click)="start4()">
            {{'LP_B2' | translate}}

          </button>-->
          <button *ngIf="samplePlayed && !sTest" mat-raised-button class="button" (click)="start3()">{{'LP_B3' |
            translate}}</button>
        </div>

        <div *ngIf="configured && sTest" style="display: flex; margin-bottom: 45.46px; margin-top: 4rem;">
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(10)" color="white"
              style="margin-left: 0.4rem;">
              10%
            </button>

          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(20)" color="white"
              style="margin-left: 0.4rem;">
              20%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(30)" color="white"
              style="margin-left: 0.4rem;">
              30%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(40)" color="white"
              style="margin-left: 0.4rem;">
              40%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(50)" color="white"
              style="margin-left: 0.4rem;">
              50%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(60)" color="white"
              style="margin-left: 0.4rem;">
              60%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(70)" color="white"
              style="margin-left: 0.4rem;">
              70%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(80)" color="white"
              style="margin-left: 0.4rem;">
              80%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(90)" color="white"
              style="margin-left: 0.4rem;">
              90%
            </button>
          </div>
          <div style="width: 20%;text-align-last: center;">
            <button mat-raised-button [disabled]="!showEval" (click)="rateInstant(100)" color="white"
              style="margin-left: 0.4rem;">
              100%
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>